import { render, staticRenderFns } from "./AgendaDateStrip.vue?vue&type=template&id=018d941e&"
import script from "./AgendaDateStrip.vue?vue&type=script&lang=js&"
export * from "./AgendaDateStrip.vue?vue&type=script&lang=js&"
import style0 from "./AgendaDateStrip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports